import React, { useContext, useEffect, useState } from 'react'
import { merge } from 'react-merge';
import { useMediaQuery } from 'react-responsive';
import { StyleContext } from '../../../providers/StyleContextProvider';

interface Props {
    styles?: any,
    checked: boolean,
    handleCheck?:() => void
}

export const RadioButton: React.FC<Props> = (props) => {    
    const styleContext = useContext(StyleContext);
    const [styles, setStyles] = useState<any>(styleContext.getComponentStyle("input"));
    const isMobile = useMediaQuery({ query: "(max-width: 786px)" });

    useEffect(() => {
        let extendedStyles = merge(styles, props.styles);
        setStyles(extendedStyles);
    }, [isMobile]);

    return (
        <div style={styles.inputContainer}>
            <div style={styles.radioButton.wrapper} onClick={props.handleCheck}>
                <div style={styles.radioButton}>
                    <div style={{ ...styles.radioButton.inner, ...(props.checked && styles.radioButton.inner.checked) }}></div>
                </div>
                <label style={styles.radioButton.text}>{props.children}</label>
            </div>
        </div>
    )
}